import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Section.module.css';
import { ChevronDownButton, ChevronRightButton, ObjectiveFlag } from '_components';

class PatientCareCenterNoteSpecTestSection extends React.Component {


    getChevron() {
        if (this.props.allowCollapse !== undefined && this.props.allowCollapse === false) {
            return (<span className={styles.no_collapse_pad} />);
        } else if (this.props.visible) {
            return (<ChevronDownButton size='extra-small' className={styles.button} onClick={() => this.props.toggleVisibility({ noteId: this.props.noteId, sectionId: this.props.id, visible: false })} />)
        } else {
            return (<ChevronRightButton size='extra-small' className={styles.button} onClick={() => this.props.toggleVisibility({ noteId: this.props.noteId, sectionId: this.props.id, visible: true })} />)
        }
    }

    renderChildren() {
        if (this.props.visible) {
            return (this.props.children);
        }
        return (<span />);
    }

    render() {
        let cls = styles.wrapper;

        if (this.props.allowCollapse !== undefined && this.props.allowCollapse === false) {
            cls += ' ' + styles.no_bold;
        }

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        let childCls = styles.child_wrapper_no_collapse;

        return (
            <div>
                <div className={styles.header_wrapper}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText={'Special Test - ' + this.props.name} />
                    <div className={cls}>
                        {this.getChevron()}
                        <span className={styles.label}>
                            {this.props.name}
                        </span>
                    </div>
                </div>
                <div className={childCls}>
                    {this.renderChildren()}
                </div>
            </div>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(noteActions.toggleSectionVisibility, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let visible = true;
    if (state.ui.notes[noteId][ownprops.id.toLowerCase() + 'Visible'] !== undefined) {
        visible = state.ui.notes[noteId][ownprops.id.toLowerCase() + 'Visible'];
    } else if (ownprops.visible !== undefined) {
        visible = ownprops.visible;
    }


    return {
        noteId: noteId,
        visible: visible
    };
}

const connectedPatientCareCenterNoteSpecTestSection = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSpecTestSection);
export { connectedPatientCareCenterNoteSpecTestSection as PatientCareCenterNoteSpecTestSection };

